import React from 'react'
import PaymentmobCard from './PaymtHistoryCard'

function MobilePaymentIndex({ data, getData }) {
  const payments = Array.isArray(data) ? data : [];

  return (
    <div className="w-full h-[calc(100vh-199px)] overflow-scroll py-1 px-2">
      {payments.length > 0 ? (
        payments.map((item, index) => (
          <PaymentmobCard item={item} getData={getData} key={index} index={index} />
        ))
      ) : (
        <div className="text-center text-gray-500 mt-4">No payment history available.</div>
      )}
    </div>
  );
}

export default MobilePaymentIndex

